import React from 'react';
import { Globe, MapPin } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
    DropdownMenuSeparator,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { useCurrency } from '../../context/CurrencyContext';

const CurrencySelector = ({ variant = 'default', showLabel = true }) => {
    const { 
        currencies, 
        selectedCurrency, 
        changeCurrency, 
        getCurrencySymbol,
        detectedCountryName,
        setShowCountrySelector
    } = useCurrency();

    const currentCurrency = currencies.find(c => c.code === selectedCurrency);

    if (currencies.length === 0) return null;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button 
                    variant={variant === 'ghost' ? 'ghost' : 'outline'} 
                    size="sm"
                    className="gap-2"
                    data-testid="currency-selector"
                >
                    <Globe className="w-4 h-4" />
                    {showLabel && (
                        <span>{getCurrencySymbol()} {selectedCurrency}</span>
                    )}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[180px]">
                {/* Current location indicator */}
                {detectedCountryName && (
                    <>
                        <div className="px-2 py-1.5 text-xs text-muted-foreground">
                            <MapPin className="w-3 h-3 inline mr-1" />
                            {detectedCountryName}
                        </div>
                        <DropdownMenuSeparator />
                    </>
                )}
                
                {/* Currency options */}
                {currencies.map((currency) => (
                    <DropdownMenuItem
                        key={currency.code}
                        onClick={() => changeCurrency(currency.code)}
                        className={`cursor-pointer ${selectedCurrency === currency.code ? 'bg-accent' : ''}`}
                        data-testid={`currency-${currency.code}`}
                    >
                        <span className="w-8 font-medium">{currency.symbol}</span>
                        <span>{currency.code}</span>
                        <span className="text-muted-foreground ml-auto text-xs">
                            {currency.name}
                        </span>
                    </DropdownMenuItem>
                ))}
                
                {/* Change country option */}
                <DropdownMenuSeparator />
                <DropdownMenuItem
                    onClick={() => setShowCountrySelector(true)}
                    className="cursor-pointer text-primary"
                    data-testid="change-country-btn"
                >
                    <MapPin className="w-4 h-4 mr-2" />
                    Change Country
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default CurrencySelector;
